/* eslint-disable import/prefer-default-export */
import fetcher from '@api/fetchers/simpleFetcher';
import { getHost } from '@utils/api-helper/host';
import fetch from '@api/fetchers';

const defaultHost = getHost();

export const fetchMyDoubts = (goalUID) =>
  fetcher(`${defaultHost}v2/doubts/learner/mine/?goal_uid=${goalUID}`);

export const fetchCatalogueTypes = (goalUID, type = 1) =>
  fetcher(
    `${defaultHost}v1/catalogues/browse/all/?goal_uid=${goalUID}&offset=0&limit=100&type=${type}`
  );

export const saveLanguagePreference = (goalUID, langUID) => {
  const body = {
    language_id: langUID,
    goal_uid: goalUID
  };
  return fetch('v2/doubts/learner/preferences/', {
    requestType: 'POST',
    body
  });
};

export const submitDoubt = (goalUID, submitDoubtDetails) => {
  const {
    uploadedImageUrl,
    selectedDoubtLanguage = {},
    selectedDoubtTopology = {},
    is_demo = false,
    isASDEnabled,
    isAiDoubtsFlow = false
  } = submitDoubtDetails;
  const body = {
    attachments: [
      {
        content_type: 'IMAGE',
        content: uploadedImageUrl,
        rank: 1
      }
    ],
    topology_uid: selectedDoubtTopology.uid,
    language: selectedDoubtLanguage.id,
    goal_uid: goalUID,
    is_demo,
    is_asd_flow: isASDEnabled,
    is_fast_doubts_flow: true,
    is_ai_doubts_flow: isAiDoubtsFlow
  };
  return fetch('v2/doubts/learner/submit/', {
    requestType: 'POST',
    body
  });
};
